import React, { useEffect, useState } from "react";
import { ReactComponent as SunIcon } from '../assets/icons/SunIcon.svg';
import { ReactComponent as RainIcon } from '../assets/icons/RainIcon.svg';
import { ReactComponent as HumidityIcon } from '../assets/icons/HumidityIcon.svg';
import { ReactComponent as WindIcon } from '../assets/icons/WindIcon.svg';
import { ReactComponent as UVIcon } from '../assets/icons/UVIcon.svg';
import { ReactComponent as TemperatureIcon } from '../assets/icons/TemperatureIcon.svg';
import { ReactComponent as PronosticoIcon } from '../assets/icons/Clima/PronosticoIcon.svg';
import { ReactComponent as MoonIcon } from '../assets/icons/MoonIcon.svg';
import { ReactComponent as DayClearSky } from '../assets/icons/Clima/DayClearSky.svg';
import { ReactComponent as NightClearSky } from '../assets/icons/Clima/NightClearSky.svg';
import { ReactComponent as DayFewCloud } from '../assets/icons/Clima/DayFewCloud.svg';
import { ReactComponent as NightFewCloud } from '../assets/icons/Clima/NightFewCloud.svg';
import { ReactComponent as LightRain } from '../assets/icons/Clima/LightRain.svg';
import { ReactComponent as Snow } from '../assets/icons/Clima/Snow.svg';
import { ReactComponent as RainSnow } from '../assets/icons/Clima/RainSnow.svg';
import { ReactComponent as LightRainSnow } from '../assets/icons/Clima/LightRainSnow.svg';
import { ReactComponent as Sleet } from '../assets/icons/Clima/Sleet.svg';
import { ReactComponent as Thunderstorm } from '../assets/icons/Clima/Thunderstorm.svg';
import { ReactComponent as ThunderstormRain } from '../assets/icons/Clima/ThunderstormRain.svg';
import { ReactComponent as AlertIcon } from '../assets/icons/Clima/AlertIcon.svg';
import LoadingSpinner from '../components/LoadingSpinner'
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const GraficoPrecipitacion = ({ datos, datosHistoricos }) => {
  const meses = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
  ];

  const data = {
    labels: meses,
    datasets: [
      {
        label: "Precipitaciones acumuladas en el mes", // Etiqueta para la línea del año actual
        data: datos,
        borderColor: "#0071bc",
        backgroundColor: "rgba(33,150,243,0.2)",
        tension: 0.0,
        borderWidth: 1,
        pointBackgroundColor: "#0071bc",
        pointBorder: 'none',
        pointRadius: 1.5,
        pointHoverRadius: 3,
        fill: true,
      },
      {
        label: "Precipitaciones acumuladas históricas", // Etiqueta para la línea de datos históricos
        data: datosHistoricos, // Usa los nuevos datos históricos aquí
        borderColor: "#f7931e",
        backgroundColor: "rgba(33,150,243,0.2)",
        tension: 0.0,
        borderWidth: 1,
        pointBackgroundColor: "#f7931e",
        pointBorder: 'none',
        pointRadius: 1.5,
        pointHoverRadius: 3,
        fill: false, // Puedes desactivar el relleno para esta línea
      },
    ],
  };

  const opciones = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          pointStyle: 'line',
          color: "#333",
          font: { family: "Effra", size: 8, weight: 'normal' },
        },
        onClick: () => null
      },
      tooltip: {
        backgroundColor: 'white',
        titleColor: '#0071bc',
          borderColor: (context) => {
    // Retorna el color de la línea del dataset actual
    return context.tooltip.dataPoints[0].dataset.borderColor;
  },
        borderWidth: 2,
        cornerRadius: 15,
        caretSize: 0,
        padding: { left: 20, right: 20, top: 5, bottom: 5 },
        displayColors: false,
        bodyFont: { family: "Effra", size: 14, weight: 'normal' },
        // Elimina el bodyColor fijo para que se aplique el color del callback
        bodyColor: '#333', 
        callbacks: {
          title: (context) => {
            return [];
          },
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${value} mm`;
          },
          // Este es el nuevo callback que cambia el color del texto de la etiqueta
          labelTextColor: (context) => {
            return context.dataset.borderColor;
          },
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "#555",
          font: { family: "Effra", size: 8, weight: 'normal' },
        },
        grid: { display: false }
      },
      y: {
        ticks: {
          color: "#555",
          font: { size: 8},
          beginAtZero: true
        },
        grid: {
          drawTicks: false,
          drawBorder: true,
          color: "transparent",
        }
      }
    }
  };
  return <Line data={data} options={opciones} />;
};
const GraficoTemperatura = ({ datos, datosHistoricos }) => {
  const meses = [
    "Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
  ];
  const data = {
    labels: meses,
    datasets: [
      {
        label: "TEMPERATURA MEDIA DEL AÑO ACTUAL", // Etiqueta para la línea actual
        data: datos,
        borderColor: "#ff6565",
        tension: 0.0,
        borderWidth: 1,
        pointBackgroundColor: "#ff6565",
        pointBorder: 'none',
        pointRadius: 1.5,
        pointHoverRadius: 3,
        fill: false, 
      },
      {
        label: "TEMPERATURA MEDIA HISTÓRICA", // Nueva etiqueta para la línea histórica
        data: datosHistoricos,
        borderColor: "#999999",
        tension: 0.0,
        borderWidth: 1,
        pointBackgroundColor: "#999999",
        pointBorder: 'none',
        pointRadius: 1.5,
        pointHoverRadius: 3,
        fill: false, 
      },
    ],
  };

  const opciones = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "start",
        labels: {
          usePointStyle: true,
          pointStyle: 'line',
          color: "#333",
          font: { family: "Effra", size: 8, weight: 'normal' },
        },
        onClick: () => null
      },
      tooltip: {
        backgroundColor: 'white',
        titleColor: '#0071bc',
          borderColor: (context) => {
    // Retorna el color de la línea del dataset actual
    return context.tooltip.dataPoints[0].dataset.borderColor;
  },
        borderWidth: 2,
        cornerRadius: 15,
        caretSize: 0,
        padding: { left: 20, right: 20, top: 5, bottom: 5 },
        displayColors: false,
        bodyFont: { family: "Effra", size: 14, weight: 'normal' },
        // Elimina el bodyColor fijo para que se aplique el color del callback
        bodyColor: '#333', 
        callbacks: {
          title: (context) => {
            return [];
          },
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            return `${value}°C`;
          },
          // Este es el nuevo callback que cambia el color del texto de la etiqueta
          labelTextColor: (context) => {
            return context.dataset.borderColor;
          },
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "#555",
          font: { family: "Effra", size: 8, weight: 'normal' },
        },
        grid: { display: false }
      },
      y: {
        ticks: {
          color: "#555",
          font: { size: 8},
          beginAtZero: true
        },
        grid: {
          drawTicks: false,
          drawBorder: true,
          color: "transparent",
        }
      }
    }
  };
  return <Line data={data} options={opciones} />;
};
const Clima = () => {
const [clima, setClima] = useState(null);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const [backgroundStyle, setBackgroundStyle] = useState({});
const [isDay, setIsDay] = useState(true);
const capitalizarPrimeraPalabra = (texto) => {
if (!texto) return "";
const palabras = texto.split(" ");
palabras[0] = palabras[0].charAt(0).toUpperCase() + palabras[0].slice(1);
return palabras.join(" ");
};
const obtenerFechaActual = () => {
const now = new Date();
return `${now.getDate()}/${now.getMonth() + 1}, ${now.getHours()}:${String(
now.getMinutes()
).padStart(2, "0")} hs`;
};
useEffect(() => {
const API_KEY = "decc5aaaf770f2b4764111e76d80ed6f";
const latitudUco = -33.5855;
const longitudUco = -69.0205;

const fetchClima = async (lat, lon) => {
try {
const response = await fetch(
`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}&lang=es`
);
if (!response.ok) throw new Error("Error al obtener los datos del clima.");
const data = await response.json();
const forecastResponse = await fetch(
`https://api.openweathermap.org/data/3.0/onecall?lat=${lat}&lon=${lon}&exclude=minutely,hourly&appid=${API_KEY}&units=metric&lang=es`
);
if (!forecastResponse.ok) throw new Error("Error al obtener el pronóstico.");
const forecastData = await forecastResponse.json();
setClima({
temp: data.main.temp,
temp_max: forecastData.daily[0].temp.max,
temp_min: forecastData.daily[0].temp.min,
oscilacion: forecastData.daily[0].temp.max - forecastData.daily[0].temp.min,
humedad: data.main.humidity,
viento: data.wind.speed,
condicion: data.weather[0].description,
lluvia: data.rain?.["1h"] || 0,
nieve: data.snow?.["1h"] || 0,
uv: forecastData.current.uvi,
weatherMain: data.weather[0].main,
weatherId: data.weather[0].id,
daily: forecastData.daily.slice(0, 7),
alerts: forecastData.alerts || [],
});
const now = new Date();
const currentHour = now.getHours();
const isDayTime = currentHour > 6 && currentHour < 20;
setIsDay(isDayTime);
setBackgroundStyle({
background: isDayTime
? "linear-gradient(to bottom, #6cc0ff 50%, #6cc0ff 100%)"
: "linear-gradient(to bottom, #1b1439 70%, #2e3192 100%)",
});
setLoading(false);
} catch (err) {
setError(err.message);
setLoading(false);
}
};

if (navigator.geolocation) {
navigator.geolocation.getCurrentPosition(
(position) => {
const { latitude, longitude } = position.coords;
fetchClima(latitude, longitude);
},
(error) => {
console.error("Error al obtener la ubicación. Usando ubicación por defecto:", error);
fetchClima(latitudUco, longitudUco);
}
);
} else {
console.error("Geolocalización no soportada. Usando ubicación por defecto.");
fetchClima(latitudUco, longitudUco);
}
}, []);

if (loading) return <LoadingSpinner></LoadingSpinner>;
if (error) return <p>Error: {error}</p>;
const temperaturaPromedio = [25.15, 23.35, 20.85, 16.00, 11.75, 8.45, 7.65, 10.45, 14.00, 18.05, 21.55, 24.30];
const temperaturaActual = [ 26, 27, 21, 16, 14, 9, 9, 12, 16, 19, 22, 25];

const precipitacionPromedio = [43.40, 42.55, 33.65, 20.90, 12.90, 6.90, 6.65, 9.00, 13.45, 12.55, 24.30, 26.25];
const precipitacionActual = [25.3, 18.7, 71.3, 26.5, 21, 7.6, 1.7, 29.3, 13, 44 , 91, 99];
const getClimaIcon = (weatherId, isDayTime) => {
const weatherIconMap = {
200: ThunderstormRain,
201: ThunderstormRain,
202: ThunderstormRain,
210: Thunderstorm,
211: Thunderstorm,
212: Thunderstorm,
221: Thunderstorm,
230: ThunderstormRain,
231: ThunderstormRain,
232: ThunderstormRain,
300: LightRain,
301: LightRain,
302: LightRain,
310: LightRain,
311: LightRain,
312: LightRain,
313: LightRain,
314: LightRain,
321: LightRain,
500: LightRain,
501: LightRain,
502: LightRain,
503: LightRain,
504: LightRain,
511: LightRainSnow,
520: LightRain,
521: LightRain,
522: LightRain,
531: LightRain,
600: Snow,
601: Snow,
602: Snow,
611: Sleet,
612: Sleet,
613: Sleet,
615: LightRainSnow,
616: LightRainSnow,
620: RainSnow,
621: RainSnow,
622: RainSnow,
701: DayFewCloud,
711: DayFewCloud,
721: DayFewCloud,
731: DayFewCloud,
741: DayFewCloud,
751: DayFewCloud,
761: DayFewCloud,
762: DayFewCloud,
771: DayFewCloud,
781: DayFewCloud,
800: isDayTime ? SunIcon : MoonIcon,
801: isDayTime ? DayFewCloud : NightFewCloud,
802: isDayTime ? DayFewCloud : NightFewCloud,
803: isDayTime ? DayFewCloud : NightFewCloud,
804: isDayTime ? DayFewCloud : NightFewCloud,
};
return weatherIconMap[weatherId] || (isDayTime ? SunIcon : MoonIcon);
};
const WeatherIconComponent = getClimaIcon(clima.weatherId, isDay);
return (
<div className="Trazabilidad">
<header className="trazabilidad-header">
<div className="header-content">
<h1 style={{ cursor: 'default' }}>Condiciones climáticas</h1>
</div>
</header>
<div className="trazabilidad-content">
<div className="clima-bloque-celeste" style={backgroundStyle}>
{}
<div className="clima-header">
<div className="clima-title" style={{ cursor: 'default' }}>
Finca «Los Astros»
</div>
<div className="clima-subtitle" style={{ cursor: 'default' }}>
Actualizado {obtenerFechaActual()}
</div>
</div>
{}
<div className="clima-fila">
{}
<div className="clima-item">
<p className="clima-valor" style={{ cursor: 'default' }}>
{Math.round(clima.temp)}°C
</p>
{WeatherIconComponent && (
<WeatherIconComponent className="clima-icon" style={{ fill: '#ffffff' }} />
)}
<p className="clima-label" style={{ cursor: 'default' }}>
{capitalizarPrimeraPalabra(clima.condicion)}
</p>
</div>
{}
<div className="clima-item">
<p className="clima-valor" style={{ cursor: 'default' }}>
{clima.lluvia} mm
</p>
<RainIcon className="clima-icon" />
<p className="clima-label" style={{ cursor: 'default' }}>
Precipitaciones
</p>
</div>
{}
<div className="clima-item">
<p className="clima-valor" style={{ cursor: 'default' }}>
{clima.humedad}%
</p>
<HumidityIcon className="clima-icon" />
<p className="clima-label" style={{ cursor: 'default' }}>
Humedad
</p>
</div>
{}
<div className="clima-item">
<p className="clima-valor" style={{ cursor: 'default' }}>
{clima.viento} m/s
</p>
<WindIcon className="clima-icon" />
<p className="clima-label" style={{ cursor: 'default' }}>
Viento
</p>
</div>
{}
<div className="clima-item">
<p className="clima-valor" style={{ cursor: 'default' }}>
{clima.uv}
</p>
<UVIcon className="clima-icon" style={{ fill: '#ffffff' }} />
<p className="clima-label" style={{ cursor: 'default' }}>
Índice UV
</p>
</div>
</div>
</div>
<div className="fila-cuadrados">
<div className="cuadrado-container" style={{ justifyContent: 'space-between' }}>
<p style={{ margin: '0', fontSize: '13px', fontWeight: '400', marginLeft: '5px', cursor: 'default' }}>
Datos diarios y acumulados
</p>
<div className="cuadrado" style={{ justifyContent: 'space-between' }}>
<div
style={{
display: 'flex',
flexDirection: 'row',
width: '90%',
margin: '10px auto 0px',
alignItems: 'center',
justifyContent: 'space-between',
gap: '5px',
}}
>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
<TemperatureIcon
className="clima-icon"
style={{ fill: '#2c2c2c', margin: 'auto 0', height: '20px', width: 'auto' }}
/>
<span style={{ fontSize: '13px', fontWeight: '300', margin: '0', cursor: 'default' }}>Temperatura del día</span>
</div>
<div style={{ display: 'flex', flexDirection: 'row', margin: '0px 0px 7px' }}>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px', margin: '0 0 0 auto' }}>
<span style={{ fontSize: '10px', fontWeight: '600', margin: '0', color: '#ff6565', cursor: 'default' }}>MAX</span>
<p style={{ fontSize: '13px', fontWeight: '300', margin: '0', cursor: 'default' }}>
{Math.round(clima.temp_max)}°
</p>
</div>
<div
style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px', margin: '0 15px' }}
>
<span style={{ fontSize: '10px', fontWeight: '600', margin: '0', color: '#0071bc', cursor: 'default' }}>MIN</span>
<p style={{ fontSize: '13px', fontWeight: '300', margin: '0', cursor: 'default' }}>
{Math.round(clima.temp_min)}°
</p>
</div>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px', margin: '0' }}>
<span style={{ fontSize: '10px', fontWeight: '600', margin: '0', color: '#2c2c2c', cursor: 'default' }}>OSC</span>
<p style={{ fontSize: '13px', fontWeight: '300', margin: '0', cursor: 'default' }}>
{Math.round(clima.oscilacion)}°
</p>
</div>
</div>
</div>
<div
style={{
display: 'flex',
alignItems: 'center',
width: '83%',
margin: '0px 0px 10px 50px',
}}
>
<div
style={{
width: '7px',
height: '7px',
borderRadius: '50%',
backgroundColor: '#dbdfe6',
}}
></div>
<div style={{ flex: 1, height: '1.5px', backgroundColor: '#dbdfe6' }}></div>
</div>
<div style={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', margin: '0 auto', width: '90%' }}>
<RainIcon className="clima-icon" style={{ fill: '#2c2c2c', margin: 'auto 0', height: '20px', width: 'auto' }} />
<span style={{ fontSize: '13px', fontWeight: '300', cursor: 'default' }}>Precipitación acumulada</span>
</div>
<div style={{ height: '62%', width: '80%', margin: 'auto 35px auto auto' }}>
<GraficoPrecipitacion datos={precipitacionActual} datosHistoricos={precipitacionPromedio} />
</div>
<div
style={{
display: 'flex',
flexDirection: 'row',
gap: '10px',
alignItems: 'center',
margin: '0 auto 10px',
width: '90%',
}}
>
<SunIcon className="clima-icon" style={{ fill: '#2c2c2c', margin: 'auto 0', height: '18px', width: 'auto' }} />
<span style={{ fontSize: '13px', fontWeight: '300', cursor: 'default' }}>
Radiación solar anual acumulada: 1183.88 horas
</span>
</div>
</div>
</div>
<div className="cuadrado-container" style={{ justifyContent: 'space-between' }}>
<p style={{ margin: '0', fontSize: '13px', fontWeight: '400', marginLeft: '5px', cursor: 'default' }}>
Gráficos históricos y comparativos
</p>
<div className="cuadrado" style={{ gap: '10px' }}>
<div
style={{
display: 'flex',
flexDirection: 'row',
width: '90%',
margin: '17px auto 0px',
alignItems: 'center',
justifyContent: 'space-between',
gap: '5px',
}}
>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
<TemperatureIcon
className="clima-icon"
style={{ fill: '#2c2c2c', margin: 'auto 0', height: '20px', width: 'auto' }}
/>
<span style={{ fontSize: '13px', fontWeight: '300', margin: '0', cursor: 'default' }}>Comparación climática</span>
</div>
</div>
<div style={{ height: '82%', width: '82%', margin: '0 25px auto auto' }}>
<GraficoTemperatura datos={temperaturaActual} datosHistoricos={temperaturaPromedio} />
</div>
</div>
</div>
<div className="cuadrado-container" style={{ justifyContent: 'space-between' }}>
<p style={{ margin: '0', fontSize: '13px', fontWeight: '400', marginLeft: '5px', cursor: 'default' }}>
Alertas y pronósticos
</p>
<div className="cuadrado">
<div
className="alerta-hoy"
style={{
background: '#f9fafd',
color: 'white',
borderRadius: '6px',
height: '45%',
alignContent: 'center',
alignItems: 'center',
display: 'flex',
flexDirection: 'row',
gap: '10px',
width: '90%',
margin: 'auto',
}}
>
{clima.alerts && clima.alerts.length > 0 ? (
<div
style={{
margin: 'auto',
display: 'flex',
flexDirection: 'row',
gap: '10px',
overflow: 'auto',
justifyContent:'start',
alignItems:'start'
}}
>
<AlertIcon style={{ width: '65px',marginTop:'5px', overflow: 'auto' }} />
<span
  style={{
    color: '#2c2c2c',
    textAlign: 'left',
    fontSize: '25px',
    fontWeight: '300',
    cursor: 'default',
  }}
>
  Alerta de {clima.alerts[0].event.toLowerCase()}.

</span>
</div>
) : (
<div
style={{
margin: 'auto',
display: 'flex',
flexDirection: 'row',
gap: '10px',
overflow: 'auto',
width: '80%',
}}
>
<span
style={{
color: '#2c2c2c',
textAlign: 'left',
fontSize: '25px',
fontWeight: '300',
cursor: 'default',
}}
>
Sin alertas meteorológicas. Condiciones normales
</span>
</div>
)}
</div>
<div className="cuadrado-siete-dias" style={backgroundStyle}>
<div
style={{
display: 'flex',
flexDirection: 'row',
alignItems: 'center',
gap: '5px',
width: '96%',
margin: '17px auto 0px',
}}
>
<PronosticoIcon
className="clima-icon"
style={{ fill: '#ffffff', margin: 'auto 0', width: 'auto', height: '16px' }}
/>
<span style={{ fontSize: '13px', fontWeight: '400', margin: '0 auto 0 0 ', color: 'white', cursor: 'default' }}>
Pronóstico a siete días
</span>
</div>
<div
style={{
display: 'flex',
flexDirection: 'row',
width: '90%',
margin: '0 auto',
justifyContent: 'center',
overflow: 'auto',
}}
>
{clima.daily &&
clima.daily.map((day, index) => {
const fecha = new Date(day.dt * 1000);
const diaNombre = index === 0 ? 'Hoy' : fecha.toLocaleDateString('es-ES', { weekday: 'short' });
const DayIcon = getClimaIcon(day.weather[0].id, true);
const NightIcon = getClimaIcon(day.weather[0].id, false);
return (
<div key={index} className="dia-clima" style={{ cursor: 'default' }}>
<p className="nombre-dia" style={{ cursor: 'default' }}>
{diaNombre}
</p>
{DayIcon && <DayIcon className="icono-dia" style={{ fill: '#ffffff' }} />}
<hr
style={{
borderTop: '1px solid #eaeef5',
opacity: '0.4',
margin: '0px 0 0px',
width: '50%',
}}
/>
{NightIcon && <NightIcon className="icono-noche" style={{ fill: '#ffffff' }} />}
<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
<p className="temp" style={{ cursor: 'default' }}>
{Math.round(day.temp.max)}°
</p>
<p className="temp" style={{ cursor: 'default' }}>
{Math.round(day.temp.min)}°
</p>
</div>
</div>
);
})}
</div>
</div>
</div>
</div>
</div>
</div>
</div>
);
};
export default Clima;
